import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=0dae6145&scoped=true"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"
import style0 from "./SelectField.vue?vue&type=style&index=0&id=0dae6145&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae6145",
  null
  
)

export default component.exports